import store from '../store'
import toast from './toast';
import confirm from "./confirm";
import user_profiler from "../components/user/small_block/user_profiler";
import menu_modal from "../components/sys/menu/menu_modal.vue";


window.IMC_VUE_SYS =  new Vue({
    store,
    el: '#imc_app',
    name : "IMCSYS",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        toast,
        menu_modal,
        confirm,
        user_profiler
    }
});
